export { default } from "./box-heading";
